// src/components/portal/portal.js
import React, { useState } from 'react';
import Login from './portal_components/login'; 
import NextUpdateInfo from './portal_components/next_update';
import Designer from './portal_components/design_settings';
import CoreConfig from './portal_components/data_settings';
import UnifiedInfoHeader from './portal_components/unified_info_header';
import NavigationBar from './portal_components/navigation_bar'; // MISSING IMPORT
import './portal.css'; // Import the CSS file

import {
  Card,
  CardContent,
  Typography,
  Box,
  CircularProgress,
  Alert,
  Container,
  Button,
  AppBar,
  Toolbar
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import LogoutIcon from '@mui/icons-material/Logout';

import portalSession from './portal_services/portal_session';

const theme = createTheme({
  palette: {
    primary: {
      main: '#009688', // Teal
    },
    background: {
      default: '#ffffff', // White
    },
  },
});

function Portal() {
  const [isLoggedIn, setIsLoggedIn] = useState(portalSession.isLoggedIn());
  const [activeSection, setActiveSection] = useState('design');

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    portalSession.clearSession();
    setIsLoggedIn(false);
  };

  // If user is not logged in, show login component
  if (!isLoggedIn) {
    return <Login onLoginSuccess={handleLoginSuccess} />;
  }

  const renderActiveSection = () => {
    switch (activeSection) {
      case 'design':
        return <Designer />;
      case 'data':
        return <CoreConfig />;
      case 'updates':
        return <NextUpdateInfo />;
      default:
        return <Designer />;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Customer Portal
          </Typography>
          <Button 
            color="inherit" 
            onClick={handleLogout}
            startIcon={<LogoutIcon />}
          >
            Logout
          </Button>
        </Toolbar>
      </AppBar>

      <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
        <UnifiedInfoHeader onLogout={handleLogout} />
        <NavigationBar 
          activeSection={activeSection} 
          onSectionChange={setActiveSection} 
        />
        <Box sx={{ pb: 4 }}>
          {renderActiveSection()}
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default Portal;